import React, { useState } from "react";
import Headline from "./Headline";
import { Button, Flex, Form, Input, Modal, notification, Radio, RadioChangeEvent } from "antd";
import HomeLink from "../../widgets/HomeLink";
import { Link, useNavigate } from "react-router-dom";
import CustomerApi from "../../api-services/customer-api.service";
import SignInForm from "./SignInForm";

type FieldType = {
  username?: string;
  password?: string;
  email?: string;
};

const bannerPath = '/iceholidays-assets/images/partner_signin_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Sign In' }
]

const SignInPage: React.FC = () => {
  const [linkForm] = Form.useForm();
  const navigate = useNavigate();

  const [signInOption, setSignInOption] = useState("default");

  const handlePageLoginSuccess = () => {
    const returnTo = new URLSearchParams(window.location.search).get('return_to');
    if (returnTo) {
      window.location.href = decodeURIComponent(returnTo);
      return;
    }
    navigate('/web');
    navigate(0); //to remove if partner sign in page returns user data
  };

  const requestLink = (formValues: FieldType) => {
    CustomerApi.requestLink(formValues)
    .then(success => {
      if(success){
        Modal.success({
          content: "If your email exists in our database, you will receive a sign-in link at your email address in a few minutes."
        });
        linkForm?.resetFields();
      }
    })
    .catch(error => {
      notification.error({ message: error.response?.data?.error || error.message || "An error occurred" });
    });
  }

  const changeSignInOption = (e: RadioChangeEvent) => {
    setSignInOption(e.target.value);
  }

  const renderContent = () => {
    switch(signInOption) {
      case "link":
       return (
        <Form
          form={linkForm}
          autoComplete="off"
          layout="vertical"
          variant="filled"
          onFinish={requestLink}
        >
          <Form.Item<FieldType>
            label="Email Address"
            name="email"
            rules={[{ required: true, message: 'Please input your email address' }, { type: "email" }]}
          >
            <Input placeholder="Enter Email Address"/>
          </Form.Item>

          <Flex align="center" justify="center">
            <Button type="primary" htmlType="submit">
              Request Link
            </Button>
          </Flex>
        </Form>
       )
      default:
       return <SignInForm onSuccess={handlePageLoginSuccess} />
    }
  }


  return (
    <div id="sign-in" className="gd-series-tour-page signin-page">
      <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
        <span className="title">
          Sign In
        </span>
      </Headline>

      <div className="gd-series-tour-page_body">
        <div className="signin-page-form">

          <Flex justify="center" vertical className="signin-page-form-header">
            <label>Sign In</label>

            <Radio.Group className="custom-tab-pill" value={signInOption} onChange={changeSignInOption}>
              <Radio.Button value="default">Via Email & Password</Radio.Button>
              <Radio.Button value="link">Via Authentication Link</Radio.Button>
            </Radio.Group>
          </Flex>

          {renderContent()}

          <Flex align="center" justify="center">
            <div id="partner-sign-in-link">
              <span>One of Our Partners? </span> <Link to="/web/partner-sign-in">Sign In Here</Link>
            </div>
          </Flex>

          {/* <div id="download-options">
            <div>
              <h2>Download the App</h2>
              <p>Scan me now</p>
            </div>

            <img id="qr" src='/iceholidays-assets/images/download_qr.png'/>

            <small>or</small>

            <Space size={14} direction="vertical" align="center">
              <a target="_blank" href="https://apps.apple.com/my/app/golden-destinations/id1446862869"><img src="/iceholidays-assets/images/social/app_store_black.png"/></a>
              <a target="_blank" href="/"><img src="/iceholidays-assets/images/social/google_play_black.png"/></a>
            </Space>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default SignInPage;
